// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};


/** Image data-src observer **/
const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const img = entry.target;
            img.srcset = img.getAttribute('data-srcset');
            img.removeAttribute('data-srcset');
            observer.unobserve(img);

        }
    });
});

document.querySelectorAll('img[data-srcset]').forEach(img => {
    observer.observe(img);
});





$(function () {

    let app = require('./modules/core')();

    // Needed straight away - form submit handling, in-page links
    app.initBootstrap();
    app.initLazyLoad();
    app.scrollToAnchor();
    app.detectUrlScrollHash();
    app.initFormSubmitState();
    app.initQuoteFormLinks();

    // The rest runs one initialiser per task, in the same order, so start-up
    // doesn't block the main thread in one long task (Total Blocking Time)
    const queue = [
        app.initSlickCarousel,
        app.scrollToAccordionItem,
        app.convertCryptedEmails,
        app.initMobileMenu,
        app.initRrssb,
        app.initPopups,
        app.initTingleModalJs,
        //app.initDatePicker,
        app.initWowJs,
        app.initStickyEl,
        app.keepTokenAlive,
        app.addActiveSlide,
        //app.initTooltips,
        app.announcementBarDismiss,
        app.navDropdownHover, // Hover instead of click on Nav dropdowns
    ];

    (function runNext() {
        const init = queue.shift();
        if (!init) return;
        init.call(app);
        setTimeout(runNext, 0);
    })();

    // let googleMaps = require('./modules/google-maps')();
    // googleMaps.assign();


    $(".megamenu").on("click", function (e) {
        e.stopPropagation();
    });

});
